import { priceGroupListSchema, priceGroupSchema, type PriceGroupWrite } from '@erp/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';
const key = ['settings', 'price-groups'];
export function usePriceGroups(enabled = true) {
  return useQuery({
    queryKey: key,
    queryFn: () => apiFetch('/api/v1/settings/price-groups', priceGroupListSchema),
    enabled,
  });
}
export function useSavePriceGroup() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string | null; input: PriceGroupWrite }) =>
      apiFetch(`/api/v1/settings/price-groups${id ? `/${id}` : ''}`, priceGroupSchema, {
        method: id ? 'PUT' : 'POST',
        body: input,
      }),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: key });
      await Promise.all(
        ['customers', 'partners', 'products', 'setup'].map((key) =>
          client.invalidateQueries({ queryKey: [key] }),
        ),
      );
    },
  });
}
